// utils/routeTracker.js

import { setStoredValue } from "../_helpers/storagehelper";

export const storeCurrentRoute = (path) => {
  const fullUrl = window.location.origin + path;
 setStoredValue("currentRoute", fullUrl);
};
